import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';

@Component({
    selector: 'app-reports-history-tab',
    imports: [
        ComponentsModule,
        NgFor
    ],
    templateUrl: './reports-history-tab.component.html',
    standalone: true,
    styleUrl: './reports-history-tab.component.scss'
})
export class ReportsHistoryTabComponent {
    testReportsHistoryData = [
        {
            id: 0,
            name: 'Packages Summary',
            requested_by: 'OMH',
            last_requested: '1 day ago',
        },
        {
            id: 1,
            name: 'Provider Responses',
            requested_by: 'OMH',
            last_requested: '',
        },
        {
            id: 2,
            name: 'Provider Responses',
            requested_by: 'LB',
            last_requested: 'Few seconds ago',
        },
        {
            id: 3,
            name: 'Time Taken to Allocate Packages',
            requested_by: 'JH',
            last_requested: '5 days ago',
        },
    ]

}
